"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const html_custom_element_1 = require("../../../lib/html-custom-element");
const custom_element_decorators_1 = require("../../../lib/custom-element-decorators");
const reactive_decorators_1 = require("../../../lib/reactive-decorators");
const translate_1 = require("../../image-properties-dialog/translate");
const calculate_warnings_1 = require("./calculate-warnings");
exports.createDimensionWarning = (translate) => {
    class ImageWarning extends html_custom_element_1.HTMLCustomElement {
        validate({ validationState, tabName, }) {
            const imageDimensions = validationState[tabName].imageDimensions;
            const containerDimensions = validationState[tabName].containerDimensions;
            const distortedWarning = calculate_warnings_1.distortedWarning(imageDimensions, containerDimensions);
            const upscaledWarning = calculate_warnings_1.upscaledWarning(imageDimensions, containerDimensions);
            if (!imageDimensions) {
                return undefined;
            }
            if (distortedWarning && upscaledWarning) {
                return this._createDistortedAndUpscaledWarning(imageDimensions, containerDimensions);
            }
            if (distortedWarning) {
                return this._createDistortedWarning(imageDimensions, containerDimensions);
            }
            if (upscaledWarning) {
                return this._createUpscaledWarning(imageDimensions, containerDimensions);
            }
        }
        _createUpscaledWarning(imageDimensions, containerDimensions) {
            if (containerDimensions.widthValue === undefined) {
                return this._createWarningForHeight(imageDimensions, containerDimensions);
            }
            if (containerDimensions.heightValue === undefined) {
                return this._createWarningForWidth(imageDimensions, containerDimensions);
            }
            return this._createWarningForDimensions(imageDimensions, containerDimensions);
        }
        _createDistortedWarning(imageDimensions, containerDimensions) {
            return {
                group: 'image-url',
                type: 'warning',
                message: this._translate('imageUrlDistortedWarning', [
                    imageDimensions.width,
                    imageDimensions.height,
                    containerDimensions.widthValue,
                    containerDimensions.heightValue,
                ]),
            };
        }
        _createDistortedAndUpscaledWarning(imageDimensions, containerDimensions) {
            return {
                group: 'image-url',
                type: 'warning',
                message: this._translate('imageUrlDistortedAndUpscaledWarning', [
                    imageDimensions.width,
                    imageDimensions.height,
                    containerDimensions.widthValue,
                    containerDimensions.heightValue,
                ]),
            };
        }
        _createWarningForHeight(imageDimensions, containerDimensions) {
            return {
                group: 'image-url',
                type: 'warning',
                message: this._translate('imageUrlUpscaledWarningOnlyHeight', [
                    imageDimensions.width,
                    imageDimensions.height,
                    containerDimensions.heightValue,
                ]),
            };
        }
        _createWarningForWidth(imageDimensions, containerDimensions) {
            return {
                group: 'image-url',
                type: 'warning',
                message: this._translate('imageUrlUpscaledWarningOnlyWidth', [
                    imageDimensions.width,
                    imageDimensions.height,
                    containerDimensions.widthValue,
                ]),
            };
        }
        _createWarningForDimensions(imageDimensions, containerDimensions) {
            return {
                group: 'image-url',
                type: 'warning',
                message: this._translate('imageUrlUpscaledWarning', [
                    imageDimensions.width,
                    imageDimensions.height,
                    containerDimensions.widthValue,
                    containerDimensions.heightValue,
                ]),
            };
        }
        _translate(key, parameters) {
            return translate(this.translations || {})(key, parameters);
        }
    }
    __decorate([
        reactive_decorators_1.JsonAttribute('translations'),
        __metadata("design:type", String)
    ], ImageWarning.prototype, "translations", void 0);
    return ImageWarning;
};
custom_element_decorators_1.CustomElement('vce-ipd-dimension-warning')(exports.createDimensionWarning(translate_1.translate));
//# sourceMappingURL=dimension-warning.js.map